import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Checkbox, Tooltip } from 'antd'
import styled from 'styled-components'
import { colours } from '@qflow/theme'

export const TableSettingsSortableItem = ({
  id,
  title,
  shownTableColumns,
  handleTableSettingsColumnChange
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  }

  return (
    <SortableItemContainer ref={setNodeRef} style={style} {...attributes}>
      <DragHandle {...listeners}>☰</DragHandle>
      <Tooltip
        title={
          shownTableColumns?.length < 2 && shownTableColumns?.includes(id)
            ? 'At least one selected column is required'
            : ''
        }
        placement="right"
      >
        <Checkbox
          disabled={
            shownTableColumns?.length < 2 && shownTableColumns?.includes(id)
          }
          defaultChecked={shownTableColumns?.includes(id)}
          onChange={e =>
            handleTableSettingsColumnChange(e, { dataIndex: id, title: title })
          }
        >
          {title}
        </Checkbox>
      </Tooltip>
    </SortableItemContainer>
  )
}

const SortableItemContainer = styled.div`
  padding: 8px;
  margin: 4px 0;
  background-color: ${colours.WHITE};
  border: 1px solid ${colours.CLOUD_GREY};
  border-radius: 5px;
`
const DragHandle = styled.span`
  cursor: grab;
  margin-right: 8px;
  padding: 4px;
  font-size: 16px;
`
